import React from 'react';
import {
  Typography,
  Button,
} from "@material-tailwind/react";
import HorizontalSeparator from '../../Utils/HorizontalSeparator.js';
import PresentationPersonnelleImage from '../../../images/PresentationPersonnelleClaudia.jpg';

const PresentationPersonnelle = () => {
  return ( 
	<div className="w-5/6 ml-auto mr-auto lg:w-3/6">
		<Typography id="Claudia" variant="h4" color="blue-gray" className="mb-2">Claudia Pellegrin</Typography>
		<div className="lg:flex lg:columns-2">
			<div className="w-3/6 lg:w-2/6 mx-auto">
				<img alt="nature" className="rounded-xl lg:w-5/6 md:mt-4 max-h-[50vh] mx-auto" src={PresentationPersonnelleImage}/>
			</div>
			<div className="flex flex-col gap-2 w-full lg:w-4/6 mt-3 text-justify">
				<Typography variant="small" color="blue-gray">Titulaire d&apos;un Brevet des Métiers d&apos;Art en facture instrumentale option piano, je me spécialise dans l&apos;entretien des pianos des particuliers, des écoles de musique et des conservatoires.</Typography>
				<Typography id="Claudia" variant="small" color="blue-gray">À l&apos;écoute de vos besoins musicaux, je porte une attention particulière à la préservation des instruments, tant sur le plan mécanique qu&apos;acoustique.</Typography>
				<Typography id="Claudia" variant="small" color="blue-gray">Basée en région lyonnaise, je me déplace en Rhône-Alpes en organisant des tournées spécifiques par département.</Typography>
				<Typography id="Claudia" variant="small" color="blue-gray"></Typography>
				<a href="/ContactForm"><Button className="mt-2">Programmer un RDV</Button></a>
				{/*<HorizontalSeparator/>
				<Typography id="ProchainesDates" variant="small" color="blue-gray">Connaître les dates de la prochaine tournée dans votre région : </Typography>
				<a href="/ProchainesTournees"><Button className="mt-2">Prochaines tournées</Button></a>*/}
			</div>
		</div>
	</div>
	)
};

export default PresentationPersonnelle;
